<template>
<div id="logsistema" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Consultar Log del Sistema" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                      <v-spacer></v-spacer>

                        <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="logsistema.camposexcel" name="LogSistema.xlsx" >
                            <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>

                        <v-dialog v-model="modal" max-width="70%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >info-circle</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Información del Registro</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-card-text>
                                    <v-layout wrap>
                                        <v-flex xs6>
                                            <v-container grid-list-md>
                                                <h6>Datos Anteriores</h6>
                                                <pre>{{ informacionModalAnterior | prettyJSON }}</pre>
                                            </v-container>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-container grid-list-md>
                                                <h6>Datos Actuales</h6>
                                                <pre>{{ informacionModal | prettyJSON }}</pre>
                                            </v-container>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cerrar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="filtros" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary darken-2 white--text titulomodal" >
                                        <v-icon class="white--text" >search</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Filtros de Búsqueda</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    &nbsp;
                                </v-card-title><br/>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center>
                                            <v-layout row wrap>
                                                <v-flex x12 s4 m4 l4>
                                                    <v-autocomplete v-model="modeloSelected" :items="modelos" :hide-no-data="true" :hide-selected="true" item-text="modelo" item-value="modelo" label="Selecciona un Modelo/Tabla" >
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex x12 s4 m4 l4>
                                                    <v-autocomplete v-model="usuarioSelected" :items="usuarios" :hide-no-data="true" :hide-selected="true" item-text="usuario" item-value="usuario" label="Selecciona un Usuario" >
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex x12 s4 m4 l4>
                                                    <v-autocomplete v-model="accionSelected" :items="acciones" :hide-no-data="true" :hide-selected="true" :return-object="true" label="Selecciona una Acción" >
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex x12 s6 m6 l6>
                                                    <v-menu offset-x ref="menu1" :close-on-content-click="false" v-model="menu1" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_ini" label="Fecha Inicial" prepend-icon="event" @blur="
                                  model.fecha_ini = parseDate(model.fecha_ini)" :rules="[validaAnio, validaFecha]" v-mask="'####-##-##'" ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="model.fecha_ini" no-title @input="menu1 = false" locale="es-mx" ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex x12 s6 m6 l6>
                                                    <v-menu offset-x ref="menu2" :close-on-content-click="false" v-model="menu2" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-on="on" v-model="model.fecha_fin" label="Fecha Final" prepend-icon="event" @blur="
                                  model.fecha_fin = parseDate(model.fecha_fin)" :rules="[validaAnio, validaFecha]" v-mask="'####-##-##'" ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="model.fecha_fin" no-title @input="menu2 = false" locale="es-mx" ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="limpiarModel()" >
                                        <v-icon>cancel</v-icon> Limpiar Filtros
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="buscar()" >
                                        <v-icon>search</v-icon> Buscar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </div>
                        <br />
                        <p></p>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="logsistema.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="openModal(props.row.anterior, props.row.datos)" title="Ver Información del Registro" v-tippy>
                                            <v-icon>info</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {},
    data: () => ({
        fab: false,
        name: "datagrid",
        columns: ["tabla", "accion", "usuario", "fecha_formato", "actions"],
        show_loading: true,
        options: {
            filterable: ["tabla", "accion", "usuario", "fecha_formato"],
            sortable: ["tabla", "accion", "usuario", "fecha_formato"],

            headings: {
                tabla: "Tabla",
                accion: "Acción",
                usuario: "Usuario",
                fecha_formato: "fecha"
            },
        },
        URL: "",
        filtros: 0,
        menu1: false,
        menu2: false,
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Consultar Log del Sistema",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            modelo: "",
            usuario: "",
            fecha_ini: "",
            fecha_fin: "",
            accion: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        usuarios: [],
        usuariosArray: [],
        modelos: [],
        acciones: ["Crear", "Editar", "Eliminar", "Todas"],
        usuarioSelected: "",
        modeloSelected: "",
        accionSelected: "",
        informacionModal: "",
        informacionModalAnterior: "",
        logsistema: {
            camposexcel: {
                Tabla: "tabla",
                Acción: "accion",
                Usuario: "usuario",
                Fecha: {
                    field: "fecha",
                    callback: function (value) {
                        return moment(String(value)).format("YYYY-MM-DD");
                    }
                },
                "Información del registro": "datos"
            },

            items: []
        }
    }),

    filters: {
        prettyJSON: function (value) {
            if (value) return JSON.stringify(JSON.parse(value), null, 4);
        }
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.logsistema.items;
            }

        },
    },
    methods: {
        validaFecha: function(fecha){        
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else 
              return true;
        },
        validaAnio: function(){            
            if (this.model.fecha_ini != "" && this.model.fecha_fin != ""){
                var inicio = moment(this.model.fecha_ini, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_fin, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')     
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."                             
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 1 año. Favor de verificar."
            }
            return true;
        },        
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (anterior, informacion) {
            this.informacionModalAnterior = anterior;
            this.informacionModal = informacion;
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.filtros = 0;
            this.modeloSelected = "Todos";
            this.usuarioSelected = "Todos";
            this.accionSelected = "Todas";
        },

        buscar() {
            if (!this.$refs.form.validate()){

            } else {
                const datos = {
                    usuario: this.usuarioSelected != "Todos" ? this.usuarioSelected : "*",
                    modelo: this.modeloSelected != "Todos" ? this.modeloSelected : "*",
                    accion: this.accionSelected != "Todas" ? this.accionSelected : "*",
                    fecha_ini: this.model.fecha_ini ? this.model.fecha_ini : "*",
                    fecha_fin: this.model.fecha_fin ? this.model.fecha_fin : "*"
                };

                for (var k in datos) {
                    this.filtros = 0;
                    if (datos[k] != "*") {
                        this.filtros = 1;
                        break;
                    }
                }

                if (this.filtros == 1) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                    
                    axios
                        .post(this.URL + "consulta_log/", datos)
                        .then(res => {
                            if (typeof res.data != "undefined") {
                                let usuariosArray = this.usuariosArray;
                                let idCliente = this.$local_storage.get("id_cliente");

                                this.logsistema.items = res.data.filter((log) => usuariosArray.includes(log.usuario) && log.cliente == idCliente);

                                for (var k in this.logsistema.items)
                                    this.logsistema.items[k].fecha_formato = moment(String(this.logsistema.items[k].fecha)).format("YYYY-MM-DD");

                            } else {
                                this.$swal({
                                    position: "center",
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al consultar los datos"
                                    //showConfirmButton: false,
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al consultar los datos"
                                //showConfirmButton: false,
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.$root.$dialogLoader.hide();
                        });
                } else {
                    this.$swal({
                        type: "info",
                        title: "Información!",
                        text: "Debe seleccionar al menos un filtro para la búsqueda."
                    });
                }
            }
            
        },

        cargarUsuarios: function () {
            let idCliente = this.$local_storage.get("id_cliente");
            let data = {
                cliente: idCliente,
                sistema: this.$sistema
            };

            axios
                .post(this.$hostname + "usuarios/obtener_usuarios_cliente/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.usuarios = res.data;
                        var userFilter = [];

                        for (var k in this.usuarios) {
                            this.usuariosArray.push(this.usuarios[k].email);
                            userFilter.push({
                                usuario: this.usuarios[k].email
                            })
                        }

                        this.usuarios = userFilter;
                        this.usuarios.push({
                            usuario: "Todos"
                        });
                        this.usuarioSelected = "Todos";
                        this.cargarModelos();
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        cargarModelos: function () {
            axios
                .get(this.URL + "modelos_log/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.modelos = res.data;
                        this.modelos.push({
                            modelo: "Todos"
                        });
                        this.modeloSelected = "Todos";
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        }
    }, //methods
    created: function () {
        this.URL = this.$hostname + "log_sistema/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..'); 
        this.limpiarModel();
        this.cargarUsuarios();
    }
};
</script>
